import { useAudioTrackContext } from 'components/app/audio-track/_mediator/audio-track.provider';
import { useSbPlayerContext } from 'components/app/storyboard/sb-player/_mediator/sb-player.provider';
import { LoaderPayload } from 'components/app/storyboard/sb-player/lib/use-loader';

const SB_LOGGER = false;

export const useSbLogger = () => {
  const { sbPlayerGetPayload } = useSbPlayerContext();
  const { wsGetCursorTime } = useAudioTrackContext();
  if (!SB_LOGGER) return;

  return {
    play: (players: Index[] | null) => {
      console.log('__PLAY', players);
    },
    regionIn: (players: Index[] | null, clipId: CellClip) => {
      console.log('__REGION_IN', players, clipId);
    },
    regionOutEx: (player: Index) => {
      console.log(`${player}__regionOut/EXCEPTION`);
    },
    player: (player: Index, clipId?: ClipId) => ({
      onInit: () => {
        console.log(player + '__onInit', clipId, sbPlayerGetPayload(player)?.loaded);
      },
      onSeek: () => {
        console.log(player + '__onSeek', clipId, sbPlayerGetPayload(player)?.loaded);
      },
    }),
    loader: ({ index, src, clipId }: LoaderPayload) => ({
      onProgress: (loaded: Seconds) => {
        console.log(`${index}[${src}]__onProgress`, clipId, loaded);
      },
      maxLoaderTime: () => {
        console.log(index + '__MAX_LOADER_TIME', clipId);
      },
      transferIdle: () => {
        console.log(index + '__TRANSFER_IDLE', clipId, sbPlayerGetPayload(index)?.loaded);
      },
      getLimit: (limit: Seconds, leftTime: Seconds) => {
        console.log(`${index}[${src}]__getLimit`, limit, leftTime);
      },
    }),
    loaderBuffer: (player: Index, clipId?: ClipId) => ({
      onBuffer: (loaded?: Seconds) => {
        console.log(player + '__onBuffer', clipId, loaded, wsGetCursorTime());
      },
      onBufferEnd: () => {
        console.log(player + '__onBufferEnd', sbPlayerGetPayload(player)?.loaded);
      },
      exception: (loaded?: Seconds) => {
        console.log(player + '__onBuffer/EXCEPTION', clipId, loaded);
      },
      regionOutEx: (loaded?: Seconds) => {
        console.log(player + '__onBuffer/EXCEPTION/regionOut', clipId, loaded);
      },
      switch: () => {
        console.log(player + '[R->B]', clipId, sbPlayerGetPayload(player)?.loaded);
      },
    }),
    loaderReady: (player: Index) => ({
      onReady: () => {
        console.log(player + '__onReady', sbPlayerGetPayload(player)?.loaded);
      },
    }),
  };
};
